import calculateVideoBitrate from './calculateVideoBitrate';
import getVideoDuration from './getVideoDuration';

async function isValidVideoBitrate(file, maxBitrate) {
  try {
    const duration = await getVideoDuration(file);
    const bitrate = calculateVideoBitrate(file.size, duration);
    return bitrate <= maxBitrate;
  } catch {
    return false;
  }
}

export default isValidVideoBitrate;
